/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideosAnswerShortCompleted
 */
export interface VideosAnswerShortCompleted {
    /**
     * 
     * @type {number}
     * @memberof VideosAnswerShortCompleted
     */
    videoId?: number;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerShortCompleted
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof VideosAnswerShortCompleted
     */
    duration?: number;
    /**
     * 
     * @type {number}
     * @memberof VideosAnswerShortCompleted
     */
    videoOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerShortCompleted
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VideosAnswerShortCompleted
     */
    completed?: boolean;
}

export function VideosAnswerShortCompletedFromJSON(json: any): VideosAnswerShortCompleted {
    return VideosAnswerShortCompletedFromJSONTyped(json, false);
}

export function VideosAnswerShortCompletedFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideosAnswerShortCompleted {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'videoId': !exists(json, 'video-id') ? undefined : json['video-id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'videoOrder': !exists(json, 'video-order') ? undefined : json['video-order'],
        'thumbnailUrl': !exists(json, 'thumbnail-url') ? undefined : json['thumbnail-url'],
        'completed': !exists(json, 'completed') ? undefined : json['completed'],
    };
}

export function VideosAnswerShortCompletedToJSON(value?: VideosAnswerShortCompleted | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'video-id': value.videoId,
        'title': value.title,
        'duration': value.duration,
        'video-order': value.videoOrder,
        'thumbnail-url': value.thumbnailUrl,
        'completed': value.completed,
    };
}


